import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DescricaoConvenioComponent } from './descricao-convenio/descricao-convenio.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent},
  { path: 'descricao-convenio/:id', component: DescricaoConvenioComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
